import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  relationShipLength: 0,
  relationShip: [],
}

export default function relationshipReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_RELATIONSHIP:
      return {...state, loading: action.payload}
    case actions.GET_RELATIONSHIP:
      return {...state, relationShip: action.payload.relationShip, relationShipLength: action.payload.relationShipLength}
    default:
      return state
  }
}